import SrpMapView from "@/components/srp";
import MetaComponent from "@/components/common/MetaComponent";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fetchSRPInitialLoad } from "@/redux/SRP/srpSlice";
import { globalCmsData } from "@/redux/cms/cmsSelectors";
import Joyride from "react-joyride";
import TakeTour from "@/components/takeTour";
import { searchSteps, tourStyles } from "@/components/takeTour/tourSteps";
import { setPageNumber } from "@/redux/SRP/propertiesSlice";
import { trackButtonClick } from "@/utils/analytics";
import { captureAttribution } from "@/utils/attributionCapture";
import { trackCategoryPageView } from "@/utils/categoryPageTrackingService";
import { buildFilterTypeFromCurrentUrl, getSrpLocationLabel } from "@/utils/filterTrackingService";

const SrpPage = () => {
  const { pathname, search } = useLocation();
  const srpCmsData = useSelector(globalCmsData);
  const dispatch = useDispatch();
  const [runTour, setRunTour] = useState(false);
  const isUserSubscribed = useSelector(
    (state) => state.login?.isUserSubscribed
  );
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);

  const {
    pageNumber,
    propertySubType,
    category,
    propertyStatus,
    occupancyStatus,
    sid,
    propertyShowMoreStatus,
    newToHubzu,
    marketingPhase,
    auctionEndingToday,
    ownItNow,
    nobuyerpremium,
    brokerCoOp,
    cashOnly,
    campaign,
    campaignId,
    campaignType,
    isPartOfCampaign,
    offers,
    searchBy,
    bedrooms,
    bathrooms,
    price,
    area,
    builtYear,
    sort,
    state,
    mapParam,
    listingType,
  } = useSelector((state) => state.properties);
  // const srpFilterInitData = useSelector((state) => state.srpFilter.srpFilterInitData);

  // Extract the location from url and eventId from the query params -- for foreclosure auction
  const params = useParams();
  const location = params.location;
  const stateId = params?.stateId;
  const cityId = params?.cityId;
  const queryParams = new URLSearchParams(window.location.search);
  const eventId = queryParams.get("eventId");
  const listingTypeURL = queryParams.getAll("listingType");

  const getSRPDetails = useCallback(async () => {
    window.scrollTo(0, 0);

    let url = "";
    propertySubType.map((type) => (url = url + `&propertySubType=${type}`));
    category.map((type) => (url = url + `&category=${type}`));
    propertyStatus.map((type) => (url = url + `&propertyStatus=${type}`));
    occupancyStatus.map((type) => (url = url + `&occupancyStatus=${type}`));
    sid.map((type) => (url = url + `&sid=${type}`));
    propertyShowMoreStatus.map(
      (type) => (url = url + `&propertyShowMoreStatus=${type}`)
    );
    state.map((state) => (url = url + `&state=${state.value}`));
    if (bedrooms) {
      url = url + `&bed=${bedrooms}`;
    }
    if (bathrooms) {
      url = url + `&bath=${bathrooms}`;
    }
    if (newToHubzu) {
      url = url + `&newToHubzu=${newToHubzu}`;
    }
    if (marketingPhase) {
      url = url + `&marketingPhase=${marketingPhase}`;
    }
    if (auctionEndingToday) {
      url = url + `&auctionEndingToday=${auctionEndingToday}`;
    }
    if (ownItNow) {
      url = url + `&ownItNow=${ownItNow}`;
    }
    if (nobuyerpremium) {
      url = url + `&nobuyerpremium=${nobuyerpremium}`;
    }
    if (brokerCoOp) {
      url = url + `&brokerCoOp=${brokerCoOp}`;
    }
    if (cashOnly) {
      url = url + `&cashOnly=${cashOnly}`;
    }
    if (campaign) {
      url = url + `&campaign=${campaign}`;
    }
    if (campaignId) {
      url = url + `&campaignId=${campaignId}`;
    }
    if (campaignType) {
      url = url + `&campaignType=${campaignType}`;
    }
    if (isPartOfCampaign) {
      url = url + `&isPartOfCampaign=${isPartOfCampaign}`;
    }
    if (offers) {
      url = url + `&offers=${offers}`;
    }
    if (searchBy) {
      url = url + `&searchBy=${searchBy}`;
    }
    if (
      (price.min || price.max) &&
      !(
        (price.min === "0" || price.min === 0) &&
        (price.max === 1000001 || price.max === 0)
      )
    ) {
      url =
        url +
        `&priceRange=${price.min || "0"}-${
          !price.max || price.max === 1000001 ? "1000000plus" : price.max
        }`;
    }
    if (
      (area.min || area.max) &&
      !(
        (area.min === "0" || area.min === 0) &&
        (area.max === 10001 || area.max === 0)
      )
    ) {
      url =
        url +
        `&squareFeetRange=${area.min || "0"}-${
          !area.max || area.max === 10001 ? "10000plus" : area.max
        }`;
    }
    if (
      (builtYear.min || builtYear.max) &&
      !(
        (builtYear.min === 1799 || builtYear.min === 0) &&
        (builtYear.max === 2011 || builtYear.max === 0)
      )
    ) {
      url =
        url +
        `&yearBuiltRange=${
          !builtYear?.min || builtYear?.min === "0"
            ? "Before 1800"
            : builtYear?.min
        }-${
          !builtYear?.max || builtYear?.max === "0"
            ? "After 2010"
            : builtYear?.max
        }`;
    }
    if (sort?.value) {
      url = url + `&${sort?.value}`;
    }
    if (listingTypeURL && listingTypeURL.length > 0) {
      url = url + `&listingType=${listingTypeURL[0]}`;
    }
    if (mapParam) {
      url =
        url +
        (mapParam?.zoomValue ? `&zoomValue=${mapParam?.zoomValue}` : "") +
        (mapParam?.swLatLng ? `&swLatLng=${mapParam?.swLatLng}` : "") +
        (mapParam?.neLatLng ? `&neLatLng=${mapParam?.neLatLng}` : "") +
        (mapParam?.centerPoint ? `&centerPoint=${mapParam?.centerPoint}` : "") +
        (mapParam?.rect ? `&rect=${mapParam?.rect}` : "");
    }


    switch (pathname) {
      case "/bank-owned":
        dispatch(fetchSRPInitialLoad({ url: `${url ? url : ""}`, pageNumber }));
        break;
      // case "/signatureseller":
      //   dispatch(fetchSRPInitialLoad({url: `&sid=signature-seller${url ? url : ""}`, pageNumber}));
      //   break;
      // case "/offmarket":
      //   dispatch(
      //     fetchSRPInitialLoad({url: `&sid=offmarket-properties${url ? url : ""}`, pageNumber})
      //   );
      //   break;
      case "/commercial":
        dispatch(fetchSRPInitialLoad({ url: `${url ? url : ""}`, pageNumber }));
        break;
      case "/foreclosures":
        dispatch(fetchSRPInitialLoad({ url: `${url ? url : ""}`, pageNumber }));
        break;
      case `/foreclosure/${location}/auctions`:
        if (eventId) {
          dispatch(
            fetchSRPInitialLoad({
              url: `/portal/${location}/auctions?eventId=${eventId}${url}`,
              pageNumber,
            })
          );
        } else {
          dispatch(
            fetchSRPInitialLoad({
              url: `/${location}/auctions${url}`,
              pageNumber,
            })
          );
        }
        break;
      case "/short-sale":
        dispatch(fetchSRPInitialLoad({ url: `${url ? url : ""}`, pageNumber }));
        break;
      case "/traditional-sale":
        dispatch(
          fetchSRPInitialLoad({
            url: `&listingType=TRNL${url ? url : ""}`,
            pageNumber,
          })
        );
        break;
      case "/auctions":
        dispatch(
          fetchSRPInitialLoad({
            url: `${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/allstates/auctions`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/auctions?rect=true${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/real-estate-auctions-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/real-estate-auctions-near-me?${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/auctions-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/auctions-near-me?${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/foreclosures-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/foreclosures-near-me?${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/bank-owned-properties-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/bank-owned-properties-near-me?${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/bank-owned-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/bank-owned-near-me?${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/short-sale-properties-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/short-sale-properties-near-me?${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/short-sale-near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/short-sale-near-me?${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/near-me`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/near-me?rect=true${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/near-by`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/near-by?rect=true${url ? `${url ? url : ""}` : ""}`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/auctions`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/auctions?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/auctions`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/auctions?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/bank-owned`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/bank-owned?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/bank-owned`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/bank-owned?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/auctions/condos`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/auctions/condos?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/auctions/condos`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/auctions/condos?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/foreclosures`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/foreclosures?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/foreclosures`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/foreclosures?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/auctions/land`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/auctions/land?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/auctions/land`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/auctions/land?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/short-sale`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/short-sale?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/short-sale`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/short-sale?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/non-bank-owned`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/non-bank-owned?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      case `/${stateId}/${cityId}/non-bank-owned`:
        dispatch(
          fetchSRPInitialLoad({
            url: `/${stateId}/${cityId}/non-bank-owned?rect=true${
              url ? `${url ? url : ""}` : ""
            }`,
            pageNumber,
          })
        );
        break;
      default:
        // dispatch(fetchSRPInitialLoad({url: `${url ? url : ''}`, pageNumber}));
        break;
    }
  }, [
    pageNumber,
    pathname,
    propertySubType,
    category,
    propertyStatus,
    occupancyStatus,
    sid,
    propertyShowMoreStatus,
    newToHubzu,
    marketingPhase,
    auctionEndingToday,
    ownItNow,
    nobuyerpremium,
    brokerCoOp,
    cashOnly,
    campaign,
    campaignId,
    campaignType,
    isPartOfCampaign,
    offers,
    searchBy,
    bedrooms,
    bathrooms,
    price,
    area,
    builtYear,
    sort,
    state,
    location,
    eventId,
    listingType,
    mapParam?.zoomValue,
    mapParam?.swLatLng,
    mapParam?.neLatLng,
    mapParam?.centerPoint,
    mapParam?.rect,
  ]);

  useEffect(() => {
    getSRPDetails(pathname);
  }, [
    pathname,
    pageNumber,
    propertySubType,
    category,
    propertyStatus,
    occupancyStatus,
    sid,
    propertyShowMoreStatus,
    newToHubzu,
    marketingPhase,
    auctionEndingToday,
    ownItNow,
    nobuyerpremium,
    brokerCoOp,
    cashOnly,
    campaign,
    campaignId,
    campaignType,
    isPartOfCampaign,
    offers,
    searchBy,
    bedrooms,
    bathrooms,
    price,
    area,
    builtYear,
    sort,
    state,
    location,
    eventId,
    listingType,
    mapParam?.zoomValue,
    mapParam?.swLatLng,
    mapParam?.neLatLng,
    mapParam?.centerPoint,
    mapParam?.rect,
  ]);

  useEffect(() => {
    if (userEmailId || isUserSubscribed) {
      getSRPDetails(pathname);
    }
  }, [userEmailId || isUserSubscribed]);

  const hasCategoryTracked = useRef(false);
  const trackedPathname = useRef(null);

  useEffect(() => {
    // Capture traffic attribution (UTM params, referrer, click IDs) on SRP entry
    captureAttribution();
  }, []);

  // Track PAGE_VIEW on SRP - fires on initial mount AND when URL changes (category switch)
  useEffect(() => {
    const fullPath = pathname + search;

    // Skip if same full URL already tracked
    if (trackedPathname.current === fullPath) {
      return;
    }

    // Skip PAGE_VIEW for /near-me and /near-by if already on SRP (it's a filter action, not a new page)
    if (trackedPathname.current && (pathname === '/near-me' || pathname === '/near-by')) {
      trackedPathname.current = fullPath;
      return;
    }

    const filterType = buildFilterTypeFromCurrentUrl();
    trackCategoryPageView({ categoryType: filterType, pageName: 'SRP' });

    // Fire GA4/GTM in parallel with the same correct data as the filter-interaction API
    trackButtonClick({
      eventName: "srp_view",
      eventSource: "SRP Load",
      eventCategory: "NEW-SRP",
      eventLabel: `Filters: ${filterType} | Location: ${getSrpLocationLabel()}`,
    });

    trackedPathname.current = fullPath;
    hasCategoryTracked.current = true;
  }, [pathname, search]);

  return (
    <>
      {/* <TakeTour page="srp" setRunTour={setRunTour} /> */}
      <Joyride
        steps={searchSteps} // Steps for the SearchPage tour
        run={runTour}
        continuous={true}
        showSkipButton={false}
        disableScrolling={true}
        spotlightClicks={false}
        beaconComponent={null}
        scrollOffset={100}
        hideBackButton={true}
        scrollToFirstStep={true}
        locale={{
          last: "Get Started",
          next: "Next",
        }}
        styles={tourStyles}
        callback={(data) => {
          const { action, index, type } = data;

          if (type === "step:after") {
            const targetElement = document.querySelector(
              searchSteps[index + 1]?.target
            );
            if (targetElement) {
              targetElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }
          // Optional: Handle tour completion
          if (data.status === "finished" || data.status === "skipped") {
            setRunTour(false);
          }
        }}
      />
      <MetaComponent />
      <SrpMapView
        srpCmsData={srpCmsData}
        pageNumber={pageNumber}
        setPageNumber={(page) => dispatch(setPageNumber(page))}
      />
    </>
  );
};

export default SrpPage;
